import { PeopleScreen } from '@/components/domain/members/PeopleScreen';

export default function PeopleFollowersScreen() {
  return <PeopleScreen listType="followers" />;
}
